import QRCode from 'qrcode';
import {getFromPayload, show, hide, getCookie} from './helpers.js';

window.authorisation = {
    setup: function () {
        //
        // This shows and hides elements when the user is logged in/out:
        // - [data-logged-in]
        // - [data-logged-out]
        //
        this.toggleLoginElements();

        //
        // This will inject the profile attributes into the DOM
        // - [data-salutation]
        // - [data-name]
        // - [data-first-name]
        // - [data-last-name]
        // - [data-phone-number]
        //
        this.injectProfileAttributes();

        //
        // Inject Subscriptions Data
        //
        this.injectSubscriptionAttributes();
    },

    /**
     * Toggle Login Elements
     */
    toggleLoginElements() {
        //
        // Is verified / logged in
        //
        let isVerified = window.authorisation.isVerified();

        //
        // Unhide Elements
        // When logged in or out we need to show different elements
        //
        show(isVerified ? '[data-logged-in]' : '[data-logged-out]');

        //
        // Hide Elements
        // When logged in or out we need to hide different elements
        //
        hide(isVerified ? '[data-logged-out]' : '[data-logged-in]');
    },


    /**
     * Inject Profile Attributes
     */
    injectProfileAttributes() {
        if (window.authorisation.isVerified()) {
            //
            // Inject static data
            //
            let inject = {
                'email': window.authorisation.getEmailAddress(),            // Is this used?
                'email-address': window.authorisation.getEmailAddress(),    // Is this used?
                'salutation': window.authorisation.getSalutation(),         // Missing
                'name': window.authorisation.getName(),
                'nickname': window.authorisation.getNickname(),
                'first-name': window.authorisation.getFirstName(),
                'last-name': window.authorisation.getLastName(),
                'phone-number': window.authorisation.getPhoneNumber(),
            };

            //
            // Inject as text
            //
            for (let i = 0; i < Object.keys(inject).length; i++) {
                let key = Object.keys(inject)[i];
                let value = inject[Object.keys(inject)[i]];
                if (value) {
                    document.querySelectorAll('[data-' + key + ']').forEach((elm) => {
                        elm.innerText = value;
                    });
                }
            }

            //
            // Inject as value
            //
            for (let i = 0; i < Object.keys(inject).length; i++) {
                let key = Object.keys(inject)[i];
                let value = inject[Object.keys(inject)[i]];
                if (value) {
                    document.querySelectorAll('[data-input-' + key + ']').forEach((elm) => {
                        elm.value = value;
                    });
                }
            }

            //
            // Edge case Newsletter Subscription
            //
            if (window.authorisation.getNewsletterSubscription() === 'yes') {
                document.querySelectorAll('[data-checkbox-newsletter-subscription]').forEach((elm) => {
                    elm.checked = true;
                });
            } else {
                document.querySelectorAll('[data-checkbox-newsletter-subscription]').forEach((elm) => {
                    elm.checked = false;
                });
            }

            //
            // Check show coupon
            //
            let tlds = [
                '@scoutdigital.co.uk',
                '@historyhit.com',
                '@mod.uk', '.mod.uk', '.edu.ar',
                '.edu.au', '.ac.at', '.ac.be',
                '.edu.br', '.edu.ca', '.edu.cl',
                '.edu.cn', '.edu.co', '.edu.cz',
                '.edu.dk', '.edu.do', '.edu.ec',
                '.edu.fi', '.edu.fr', '.edu.de',
                '.edu.gr', '.edu.in', '.ac.id',
                '.edu.ie', '.ac.il', '.edu.it',
                '.ac.jp', '.ac.ke', '.edu.my',
                '.edu.mx', '.ac.nz', '.edu.ng',
                '.edu.no', '.edu.pk', '.edu.pe',
                '.edu.ph', '.edu.pl', '.edu.pt',
                '.edu.ru', '.ac.za', '.ac.kr',
                '.edu.es', '.ac.lk', '.edu.se',
                '.edu.ch', '.ac.th', '.edu.tr',
                '.ac.uk', '.edu', '.edu.ve',
            ];
            if (tlds.some(el => window.authorisation.getEmailAddress().endsWith(el))) {
                show('[data-coupon]');
            }
        }
    },

    /**
     * Inject Subscription Attributes
     * @param cname
     * @returns {string|null}
     */
    injectSubscriptionAttributes() {
        //
        // Get Subscription Status
        //
        if (this.isVerified()) {
            let isSubscribedAudioAndVideo = window.authorisation.isSubscribed('subscription_audio_and_video');

            //
            // Is Subscribed to Anything
            //
            if (isSubscribedAudioAndVideo) {
                //
                // Inject Audio Specific Attributes
                //
                this.injectAudioSubscriptionAttributes();

                show('[data-subscription]');
                hide('[data-no-subscription]');

                //
                // Show / Hide Subscription Source(s):
                // - [data-subscription-source-web]
                // - [data-subscription-source-app]
                // - [data-subscription-source-api]
                //
                switch (window.authorisation.getSubscriptionSource()) {
                    case 'web':
                        show('[data-subscription-source-web]');
                        hide('[data-subscription-source-app]');
                        hide('[data-subscription-source-api]');
                        break;
                    case 'app':
                        hide('[data-subscription-source-web]');
                        show('[data-subscription-source-app]');
                        hide('[data-subscription-source-api]');
                        break;
                    case 'api':
                    default:
                        hide('[data-subscription-source-web]');
                        hide('[data-subscription-source-app]');
                        show('[data-subscription-source-api]');
                }
            } else {
                hide('[data-subscription]');
                show('[data-no-subscription]');
            }
        }
    },

    /**
     * Add the audio subscription attributes
     *
     * 1. For each feed { 6426bae90e4e660011fd48d1: {...}, ... }
     *  a. Query the [data-subscription-podcast-6426bae90e4e660011fd48d1-url] and set the url
     *  b. Query the [data-subscription-podcast-6426bae90e4e660011fd48d1-qr] and set the src
     */
    injectAudioSubscriptionAttributes() {
        let feeds = window.authorisation.getServiceACastFeeds();

        //
        // 1
        //
        for (let i = 0; i < Object.keys(feeds).length; i++) {
            let key = Object.keys(feeds)[i];
            let value = feeds[Object.keys(feeds)[i]];

            //
            // 1.a
            //
            let feedUrlElements = document.querySelectorAll('[data-subscription-podcast-' + key + '-url]');

            feedUrlElements.forEach(function (button) {
                button.href = value;
            });

            //
            // 1.b
            //
            let feedQrElements = document.querySelectorAll('[data-subscription-podcast-' + key + '-qr]');

            feedQrElements.forEach(function (element) {
                QRCode.toCanvas(element, value, function (error) {
                    if (error) {
                        console.error(error)
                        console.log('success!');
                    }
                })
            });
        }
    },

    //
    // Methods
    //

    isVerified: function () {
        return !!window.authorisation.getToken();
    },

    //
    // Getters
    //

    getToken: function () {
        return getCookie('token');
    },

    getSalutation() {
        return getFromPayload('https://login.historyhit.com/' + 'salutation');
    },

    getNickname() {
        return getFromPayload('nickname');
    },

    getFirstName() {
        return getFromPayload('given_name');
    },

    getLastName() {
        return getFromPayload('family_name');
    },

    getName() {
        return getFromPayload('name');
    },

    getEmailAddress() {
        return getFromPayload('email');
    },

    getPhoneNumber() {
        return getFromPayload('https://login.historyhit.com/' + 'phone_number');
    },

    getNewsletterSubscription() {
        return getFromPayload('https://login.historyhit.com/' + 'newsletter_subscription');
    },

    isSubscribed(subscription_name = 'subscription_audio_and_video') {
        try {
            return getFromPayload('https://login.historyhit.com/' + subscription_name + '_status');
        } catch (e) {
            return false;
        }
    },

    getServiceACastFeeds() {
        try {
            return getFromPayload('https://login.historyhit.com/service_acast_feeds');
        } catch (e) {
            return [];
        }
    },

    //
    // Is Onboarded
    //

    getIsOnboarded() {
        return getFromPayload('https://login.historyhit.com/' + 'is_onboarded');
    },

    getSubscriptionSource() {
        return getFromPayload('https://login.historyhit.com/' + 'subscription_source');
    },

    //
    // Form
    //
};
